import React, { useState,useEffect } from 'react';
import InputText from '../../components/InputText';
import Tag from '../../components/Tag';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import AnamneseWindow from '../../components/AnamneseWindow';
import { handleBilanSelectById, handleAnalyseSelectById,hasCommentsToBeCompleted } from '../../utilities/utils';
import clsx from "clsx";

export default function Form3({ hidden, specieId, analyses, setAnalyses, matrix, bilans, setBilans, cost, activePrescriber }) {

    const [displayBilan, setDisplayBilan] = useState(false);
    const [windowAnamnese, setWindowAnamnese] = useState({ id: "", display: false, type: "" });

    //Array des labels des categories à afficher
    const [displayedCategory, setDisplayedCategory] = useState([]);
    const [displayedBilans, setDisplayedBilans] = useState([]);

    //On ré-initialise lors d'un changement d'espace
    useEffect(()=>{
        setDisplayedBilans([])
        setDisplayedCategory([])
    },[specieId])

    const ActivePrescriber = () => {

        if (activePrescriber) {
            return (
                <div className="border-b border-light-gray flex items-center justify-center p-2">
                    <h1 className="text-base">PRESCRIPTEUR ACTIF:</h1>
                    <p className="italic text-dark-green ml-3">{activePrescriber.individual.first_name + activePrescriber.individual.last_name + " - " + activePrescriber.individual.email}</p>
                </div>
            )
        }
    }

    const handleSelectAnalyse = (id,isBilan) => {
        const checked = handleAnalyseSelectById(id, isBilan, setAnalyses, analyses)
        const type = isBilan ? "falseBilan":"analyse"
        if(checked && hasCommentsToBeCompleted(id, type ,analyses, bilans)){
            setWindowAnamnese({ id: id, display: true, type: isBilan?"falseBilan":"analyse" })
        }
        
    }

    const handleSelectBilan = (id) => {
        const checked = handleBilanSelectById(id, bilans, setBilans, setAnalyses)
        if(checked && hasCommentsToBeCompleted(id, "bilan", analyses, bilans)){
            setWindowAnamnese({ id: id, display: true, type: "bilan" })
        }
    }

    return (
        <>
            <AnamneseWindow  display={windowAnamnese.display} id={windowAnamnese.id} type ={windowAnamnese.type} closeWindow={()=>setWindowAnamnese({id:"",display:false,type:""})} setAnalyses={setAnalyses} analyses={analyses} bilans={bilans} setBilans={setBilans} />
            <div className={hidden ? "hidden" : "flex flex-row flex-wrap mx-5 gap-5"}>
                <div className="box-container max-w-[800px] max-h-[650px] min-h-[700px] min-w-[500px] overflow-hidden flex flex-col flex-1">
                    <ActivePrescriber />
                    <div className="flex justify-between items-center border-b border-light-gray px-3 pt-3">
                        <div className="flex gap-3">
                            <Tab title="ANALYSES" selected={!displayBilan} onClick={() => setDisplayBilan(false)} />
                            <Tab title="BILANS" selected={displayBilan} onClick={() => setDisplayBilan(true)} />
                        </div>
                        <SearchPopUp analyses={analyses} bilans={bilans} matrix={matrix} handleSelectAnalyse={handleSelectAnalyse} handleSelectBilan={handleSelectBilan} />
                    </div>
                    <div className="flex flex-wrap gap-2 justify-around p-2 border-b border-light-gray">
                        {displayBilan ? "" : analyses.map((category) => <TagAnalyse key={specieId + category.code} category={category} displayedCategory={displayedCategory} setDisplayedCategory={setDisplayedCategory} />)}
                        {displayBilan ? bilans.map((bilan) => <TagBilan key={bilan.id} bilan={bilan} displayedBilans={displayedBilans} setDisplayedBilans={setDisplayedBilans} />) : ""}
                    </div>
                    {(displayedCategory.length > 0 || displayedBilans.length > 0) ? "" : (<p className="text-2xl text-light-green m-5 flex justify-center">Veuillez sélectionner une ou plusieurs catégories ci-dessus</p>)}
                    <div className="px-3 pb-3 overflow-y-auto">
                        {displayBilan ? "" : displayedCategory.toReversed().map((name) => <AnalyseBox key={specieId + name} name={name} analyses={analyses} matrix={matrix} handleSelectAnalyse={handleSelectAnalyse} />)}
                        {displayBilan ? displayedBilans.toReversed().map((id) => <BilanBox key={id} matrix={matrix} id={id} bilans={bilans} handleSelectBilan={handleSelectBilan} />) : ""}
                    </div>
                </div>
                <div className="box-container overflow-hidden min-w-80 max-w-80 flex-1">
                    {(analyses.length === 0 || bilans.length === 0) ? "" : <RecapBox analyses={analyses} matrix={matrix} handleSelectAnalyse={handleSelectAnalyse} bilans={bilans} handleSelectBilan={handleSelectBilan} />}
                    <div className="border-t border-light-gray flex flex-col items-end px-2 pb-1">
                        <p className="text-sm font-medium text-dark-green">TOTAL (HTVA): {cost.toFixed(2)} €</p>
                        <p className="text-sm font-medium text-dark-green">TOTAL (TVAC 21%): {(cost + Math.round(cost * 100 * 0.21) / 100).toFixed(2)} €</p>
                    </div>
                </div>
            </div>
        </>
    );
}

function AnalyseBox({ name, analyses, matrix, handleSelectAnalyse }) {

    const category = analyses.find((item) => item.label === name);

    const matrixCN = {
        container: "flex flex-row gap-1",
        img: "size-4 m-auto cursor-help"
    }

    const lineCN = {
        matrix: matrixCN,
        price: "ml-1 mr-5",
        label: "ml-2 cursor-pointer hover:font-medium",
    }

    const lineCNSelected = {
        matrix: matrixCN,
        price: "ml-1 mr-5 text-gray",
        label: "ml-2 font-medium cursor-pointer",
    }

    const lineCNLocked = {
        matrix: matrixCN,
        price: "ml-1 mr-5 text-gray",
        label: "ml-2 text-gray"
    }

    const lineCNLockedAndSelected = {
        matrix: matrixCN,
        price: "ml-1 mr-5 text-gray",
        label: "ml-2 text-gray font-medium"
    }


    const AnalyseLine = ({ item, handleSelect }) => {

        let style;
        if ((item.locked && item.checked) || item.already_ordered) {
            style = lineCNLockedAndSelected;
        }
        else if (item.checked) {
            style = lineCNSelected;
        }
        else if (item.locked || item.prescriptible === false) {
            style = lineCNLocked;
        }
        else {
            style = lineCN;
        }

        let matrixArray = [];
        if (item.matrix !== undefined) {
            matrixArray = item.matrix;
        }

        return (
            <>
                <div className={style.matrix.container}>{matrixArray.map((id) => <img alt="" key={id} className={style.matrix.img} src={matrix.find((matrix) => matrix.id === id)?.image} title={matrix.find((matrix) => matrix.id === id)?.label}></img>)}</div>
                <div className={style.price}>{item.price.toFixed(2)} €</div>
                <input type="checkbox" checked={item.checked || item.already_ordered} name={item.id} disabled={(item.locked || item.prescriptible === false) || item.already_ordered} onChange={(item.locked || item.prescriptible === false || item.already_ordered) ? () => { } : handleSelect} />
                <div className={style.label} onClick={(item.locked || item.prescriptible === false || item.already_ordered) ? () => { } : handleSelect}>{item.label}</div>
            </>
        )

    }


    return (
        <div className="labeled-container-div min-h-28 pr-24" style={{ borderColor: category.color }}>
            <p className="labeled-container-p">{category.label}</p>
            <div className="grid grid-cols-[repeat(4,max-content)]">
                {category.bilans.map((bilan) => <AnalyseLine key={bilan.id} item={bilan} handleSelect={() => handleSelectAnalyse(bilan.id, true)} />)}
                {category.analyses.map((analyse) => <AnalyseLine key={analyse.id} item={analyse} handleSelect={() => handleSelectAnalyse(analyse.id, false)} />)}
            </div>
            <img className="size-20 absolute top-2 right-2" alt="" src={category.image}></img>
        </div>
    )
}
function BilanBox({ id, bilans, handleSelectBilan, matrix}) {

    const bilan = bilans.find((item) => item.id === id);

    const TitleBox = () => {

        if (bilan.locked || bilan.prescriptible === false || bilan.already_ordered) {
            return (
                <div className="absolute -top-5 left-3 flex gap-5">
                    <div className="bg-white flex items-center border-2 border-light-green rounded-full px-3 py-1 gap-2">
                        <input type="checkbox" id={bilan.id} checked={bilan.checked || bilan.already_ordered} disabled readOnly />
                        <label className="text-md text-gray font-medium" htmlFor={bilan.id}>{bilan.label}</label>
                        <div className="flex gap-1">
                            {bilan.matrix.map((id) => <img key={id} className="size-4 cursor-help" alt="" src={matrix.find((mat) => mat.id === id).image} title={matrix.find((matrix) => matrix.id === id).label} />)}
                        </div>
                    </div>
                    <div className="bg-white flex items-center border-2 border-light-green rounded-full px-3 py-1">
                        <p className="text-md text-gray font-medium">{bilan.price.toFixed(2)} €</p>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="absolute -top-5 left-3 flex gap-5">
                    <div className="bg-white flex items-center border-2 border-light-green rounded-full px-3 py-1 gap-2">
                        <input type="checkbox" id={bilan.id} checked={bilan.checked || bilan.already_ordered} onChange={() => handleSelectBilan(bilan.id)} />
                        <label className="text-md text-dark-green font-medium cursor-pointer" htmlFor={bilan.id}>{bilan.label}</label>
                        <div className="flex gap-1">
                            {bilan.matrix.map((id) => <img key={id} className="size-4 cursor-help" alt="" src={matrix.find((mat) => mat.id === id).image} title={matrix.find((matrix) => matrix.id === id).label} />)}
                        </div>
                    </div>
                    <div className="bg-white flex items-center border-2 border-light-green rounded-full px-3 py-1">
                        <p className="text-md text-dark-green font-medium">{bilan.price.toFixed(2)} €</p>
                    </div>
                </div>
            )
        }
    }

    if (bilan != null) {
        return (
            <div className="relative border-2 border-light-green rounded-lg mt-7 p-2 min-h-28 pr-24">
                <TitleBox />
                <div className="text-dark-green p-1 pt-4">
                    {parse(DOMPurify.sanitize(bilan.text))}
                </div>
                <img className="size-20 absolute top-2 right-2" alt="" src={bilan.icon}></img>
            </div>
        )
    };
}
function TagAnalyse({ category, displayedCategory, setDisplayedCategory }) {

    //Changement d'état actif<->inactif au click
    const handleCategorySelect = (name) => {
        if (displayedCategory.includes(name)) {
            setDisplayedCategory(displayedCategory.filter((item) => !(item === name)));
        } else {
            setDisplayedCategory(displayedCategory.concat(name));
        }
    }
    return (
        <Tag className={(category.bilans?.length>0 || category.analyses?.length>0)?"":"hidden"} label={category.label} image={category.image} color={category.color} active={displayedCategory.includes(category.label) ? true : false} onClick={() => handleCategorySelect(category.label)} />
    )
}
function TagBilan({ bilan, displayedBilans, setDisplayedBilans }) {

    //Changement d'état actif<->inactif au click
    const handleBilanSelect = (id) => {
        if (displayedBilans.includes(id)) {
            setDisplayedBilans(displayedBilans.filter((item) => !(item === id)));
        } else {
            setDisplayedBilans(displayedBilans.concat(id));
        }
    }
    return (
        <Tag label={bilan.label} image={bilan.icon} color={"rgb(110,165,173)"} active={displayedBilans.includes(bilan.id) ? true : false} onClick={() => handleBilanSelect(bilan.id)} />
    )
}
function SearchPopUp({ analyses, bilans, matrix, handleSelectAnalyse, handleSelectBilan }) {
    const [hidden, setHidden] = useState(true);
    const [correspondingAnalyses, setCorrespondingAnalyses] = useState([]);
    const [correspondingBilans, setCorrespondingBilans] = useState([]);
    const [input, setInput] = useState("");
    const [isAnyCorrespondance, setIsAnyCorrespondance] = useState(false);

    const handleInputChange = (e) => {
        setIsAnyCorrespondance(false);
        setInput(e.target.value);
        if (e.target.value.length > 2) {
            setHidden(false);
            const text = e.target.value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();
            const regex = new RegExp(".*" + text + ".*");

            const filterFct = (item) => {
                if (regex.test(item.label.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase())) {
                    setIsAnyCorrespondance(true);
                }

                return regex.test(item.label.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase());
            }

            setCorrespondingAnalyses(analyses.map((category) => {
                return {
                    ...category,
                    bilans: category.bilans.filter(filterFct),
                    analyses: category.analyses.filter(filterFct)
                }
            }));

            setCorrespondingBilans(bilans.filter(filterFct));

        } else {
            setHidden(true);
        }
    }

    const handleFocusIn = (e) => {
        if (e.target.value.length > 3) {
            setHidden(false);
        }
    }
    const handleClose = () => {
        setHidden(true);
    }
    const handleDeleteSearch = () => {
        setInput("");
        setHidden(true);
    }
    const clickOnResult = (id, isAlreadyChecked, type) => {
        //type: case "analyse" case "falseBilan" case "bilan"
        if (!isAlreadyChecked) {
            if (type === "analyse") {
                handleSelectAnalyse(id, false);
            } else if (type === "falseBilan") {
                handleSelectAnalyse(id, true);
            } else if (type === "bilan") {
                handleSelectBilan(id);
            }
            handleDeleteSearch();
        }
    }

    const Analyses = () => {

        return (
            <>
                {correspondingAnalyses.filter((item) => (item.analyses.length > 0 || item.bilans.length > 0)).length > 0 ? <h2 className="text-sm text-dark-green my-1 mx-2 font-medium">Analyses</h2> : ""}
                {correspondingAnalyses.map((category) =>
                    <React.Fragment key={category.id}>
                        {category.bilans.map((bilan) =>
                            <div key={bilan.id} className={clsx(bilan.prescriptible === false ? "text-light-gray cursor-not-allowed" : "text-dark-green hover:bg-light-gray cursor-pointer", "flex flex-row items-center p-1 gap-2 text-sm")} onClick={bilan.prescriptible === false ? () => { } : () => clickOnResult(bilan.id, bilan.checked, "falseBilan")} >
                                {bilan.matrix.map((id) => <img className="size-4" src={matrix.find((matrix) => matrix.id === id).image} alt=""></img>)}&nbsp;
                                {bilan.label}&nbsp;-&nbsp;
                                {bilan.price}€
                            </div>
                        )}
                    </React.Fragment>
                )}
                {correspondingAnalyses.map((category) =>
                    <React.Fragment key={category.id}>
                        {category.analyses.map((analyse) =>
                            <div key={analyse.id} className={clsx(analyse.prescriptible === false ? "text-light-gray cursor-not-allowed" : "text-dark-green hover:bg-light-gray cursor-pointer", "flex flex-row items-center p-1 gap-2 text-sm")} onClick={analyse.prescriptible === false ? () => { } : () => clickOnResult(analyse.id, analyse.checked, "analyse")} >
                                {analyse.matrix.map((id) => <img className="size-4" src={matrix.find((matrix) => matrix.id === id).image} alt=""></img>)}&nbsp;
                                {analyse.label}&nbsp;-&nbsp;
                                {analyse.price}€
                            </div>
                        )}
                    </React.Fragment>
                )}
            </>
        );
    }

    const Bilans = () => {

        return (
            <>
                {correspondingBilans.length > 0 ? <h2 className="text-sm text-dark-green my-1 mx-2 font-medium">Bilans</h2> : ""}
                {correspondingBilans.map((bilan) =>
                    <div key={bilan.id} className={clsx(bilan.prescriptible === false ? "text-light-gray cursor-not-allowed" : "text-dark-green hover:bg-light-gray cursor-pointer", "flex flex-row items-center p-1 gap-2 text-sm")} onClick={bilan.prescriptible === false ? () => { } : () => clickOnResult(bilan.id, bilan.checked, "bilan")} >
                        {bilan.matrix.map((id) => <img className="size-4" src={matrix.find((matrix) => matrix.id === id).image} alt=""></img>)}&nbsp;
                        {bilan.label}&nbsp;-&nbsp;
                        {bilan.price}€
                    </div>
                )}
            </>
        );
    }

    return (
        <div className="relative w-64">
            <InputText placeholder="Recherche" onChange={handleInputChange} onClick={handleFocusIn} value={input} />
            <div className={"absolute z-50 border border-light-gray bg-white min-w-64 " + (hidden ? "hidden" : "")} onMouseLeave={handleClose}>
                {!isAnyCorrespondance ? <p className="text-dark-green m-2">Aucun résultat...</p> : <><Analyses /><Bilans /></>}
            </div>
            <img className={input.length === 0 ? "hidden" : "absolute top-2 right-2 size-6 cursor-pointer"} src="/cross-delete.svg" alt="" onClick={handleDeleteSearch}></img>
        </div>
    );
}
function RecapBox({ analyses, matrix, handleSelectAnalyse, handleSelectBilan, bilans }) {

    const lineCN = {
        price: "mx-2",
        label: "mx-2 mb-1 leading-tight",
        matrix: {
            container: "flex gap-1 flex-wrap",
            img: "size-4 cursor-help"
        },
        trash: {
            container: "flex",
            img: "size-4 cursor-pointer"
        }
    }

    const lineCNAlreadyOrdered = {
        price: "mx-2 text-gray opacity-0 cursor-default",
        label: "mx-2 mb-1 leading-tight text-gray",
        matrix: {
            container: "flex gap-1 flex-wrap",
            img: "size-4 cursor-help"
        },
        trash: {
            container: "flex",
            img: "size-4 hidden"
        }
    }

    const RecapLine = ({ item, handleSelect }) => {

        const style = item.already_ordered ? lineCNAlreadyOrdered : lineCN;

        if ((!(item.checked === false || item.checked === undefined) && (item.locked === false || item.locked === undefined)) || (item.already_ordered))
            return (
                <>
                    <div className={style.matrix.container}>{item.matrix.map((id) => <img alt="" key={id} className={style.matrix.img} src={matrix.find((matrix) => matrix.id === id)?.image} title={matrix.find((matrix) => matrix.id === id)?.label} />)}</div>
                    <p className={style.label}>{item.label}</p>
                    <div className={style.price}>{item.price.toFixed(2)} €</div>
                    <div className={style.trash.container}><img alt="" className={style.trash.img} src="/trash.svg" onClick={handleSelect}></img></div>
                </>
            );
    }

    return (
        <div className="flex flex-col py-2 px-3">
            <h2 className="text-base">Récapitulatif (Analyses)</h2>
            <div className="grid grid-cols-[auto_auto_65px_15px] text-sm">
                {analyses.map((category) => category.bilans.map((item) => <RecapLine key={item.id} item={item} handleSelect={() => handleSelectAnalyse(item.id, true)} />))}
                {analyses.map((category) => category.analyses.map((item) => <RecapLine key={item.id} item={item} handleSelect={() => handleSelectAnalyse(item.id, false)} />))}
            </div>
            <h2 className="text-base mt-2">Récapitulatif (Bilans)</h2>
            <div className="grid grid-cols-[auto_auto_65px_15px] text-sm">
                {bilans.map((bilan) => <RecapLine key={bilan.id} item={bilan} handleSelect={() => handleSelectBilan(bilan.id)} />)}
            </div>
        </div>
    );

}
function Tab({ title, selected, onClick }) {

    return (
        <div className={"border-t border-r border-l border-light-gray py-3 px-4 rounded-t-lg cursor-pointer" + (selected ? " bg-[#ebebeb]" : " bg-white")} onClick={onClick}>
            <p className="text-base font-medium text-dark-green">{title}</p>
        </div>
    )
}
